<article class="large-4 medium-12 small-12 pull-right pad-t-15 round-wrap-parent">
    <div class="round-wrap wifiPaymentDetails">
        <div class="row-block">
            <div class="payment-sub-total" *ngIf="giftCardAdded">
                <ul>
                    <li class="row-block">
                        <span class="pull-left">
              <h3 style="font-size:14px !important; padding:0; padding-top: 3px;">
                {{'redeem.voucher.subTotal' | translate}}</h3>
            </span>
                        <span class="pull-right">
              <strong>{{wifiKey*price | formatPrice:true:true:'no' }}</strong>
            </span>
                    </li>
                    <span *ngFor="let amt of addedVoucherAmount">
            <li class="row-block" *ngIf="amt.amount > 0">
              <span class="pull-left">{{'redeem.voucher.giftCard' | translate}} {{amt.endsWith}}</span>
                    <span class="pull-right">-{{amt.amount | formatPrice:true:true:'no'}}</span>
                    </li>
                    </span>
                </ul>
            </div>
            <div class="pull-left">
                <h3 class="pad-b-10" *ngIf="!giftCardAdded">{{'total' | translate}}</h3>
                <h3 class="pad-b-10" *ngIf="giftCardAdded" style="padding-top:20px; font-size:18px">{{'total' | translate}}</h3>
                <p class="pad-b-10">{{'taxIncluded' | translate}}</p>
            </div>
            <div class="pull-right bold font-18 pad-b-10" *ngIf="!giftCardAdded">
                {{wifiKey*price | formatPrice:true:true:'no' }}</div>
            <div class="pull-right bold font-18 pad-b-10" *ngIf="giftCardAdded" style="padding-top:15px">
                {{(giftCardTotal ? giftCardTotal : 0) | formatPrice:true:true:'no'}}
            </div>
        </div>
        <div class="checkbox-wrap row-block mrgn-t-10 paymentTnCondition">
            <div class="tool-tip bottom-left error small terms-tool-tip" role="alert" *ngIf="showTandCErrorTooltip">
                <div class="tool-tip-inner">
                    <span>{{'message.7011057'|translate}}</span>
                </div>
            </div>
            <input type="checkbox" id="terms" name="paymentTnCondition" [checked]="paymentTnC" (change)="optionChecked()" tabindex="0" role="checkbox" [attr.aria-label]="('wifiLogin.label.sasTnC' | translate)+' '+('wifiLogin.sasTnC' | translate)">

            <label for="terms" aria-labelledby="aria-labell text">
        <span class="icon-ok" id="sasTcPay"></span>
        <span class="label-content">{{'wifiLogin.label.sasTnC' | translate}}
          <a href="javascript:void(0)" (click)="openSasPaymentTnC()" id="sasPaymentTermsId" tabindex="0"
            (keydown.tab)="onTabFromtANDc($event);">{{'wifiLogin.sasTnC' | translate}}</a>
        </span>
      </label>
        </div>
        <app-terms-and-conditions *ngIf="showSasTnC" [showSasTnC]="showSasTnC" [sasTnC]="sasTnC" showSasPaymentTnC (closeSasTnCEvent)="closeSasTnCEvent()"></app-terms-and-conditions>
        <button class="btn medium primary large-12 medium-12 small-12 mrgn-t-20 sasPaymentPayNowButton" id="sasPaymentPayNowButton" (click)="proceedToConfirmation()" tabindex="0">
      <span *ngIf="!showPaymentBtnLoader">{{'payNow' | translate}}</span>
      <ul class="spinner white-bg paybtn" *ngIf="showPaymentBtnLoader">
        <li class="bounce1"></li>
        <li class="bounce2"></li>
        <li class="bounce3"></li>
      </ul>
    </button>
    </div>
</article>